<template>
    <div class="tab-pane fade" id="recharges">
        <h3>Danh sách thanh toán</h3>
        <div class="table-responsive">
            <hpo-filter :headers="recharge_headers" :viewName="'account_recharges'" v-on:applyFilter="applyFilterRecharge"
                v-on:quickFilter="quickFilterRecharge"></hpo-filter>
            <v-data-table :headers="recharge_headers" :items="recharges" :options.sync="recharge_pagination"
                :server-items-length="total_recharge" :footer-props="items_per_page" :must-sort="true" :loading="loading"
                :mobile-breakpoint="100" class="elevation-1 free-col">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>TT{{ pad(item.id, 6) }}</td>
                        <td>{{ item.created_at | display_date }}</td>
                        <td>{{ item.trade_content }}</td>
                        <td class="text-right">{{ item.amount | currency }}</td>
                    </tr>
                </template>
                <template v-slot:body.append v-if="summary_recharge">
                    <tr class="total-summary-td">
                        <td colspan="3" class="text-center font-weight-bold">Tổng</td>
                        <td class="text-end font-weight-bold">{{ summary_recharge.amount | currency }}</td>
                    </tr>
                </template>
            </v-data-table>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from '@/configs'
import Filtering from "@/components/Filtering";
import _ from 'lodash';
import { display_color } from "@/commons/formater";
import { pad } from '@/commons/utils'
export default {
    components: {
        "hpo-filter": Filtering
    },
    data () {
        return {
            viewName: "account_returns",
            pad: pad,
            display_color: display_color,
            recharge_headers: [{
                    text: "Mã TT",
                    value: "id",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Ngày tạo",
                    value: "created_at",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Nội dung",
                    value: "trade_content",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Tổng tiền",
                    value: "total",
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE["Number"]
                }
            ],
            recharge_pagination: {...configs.PAGINATION, itemsPerPage: 10},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            filterRechargeConditions: [],
            quickFilterRechargeConditions: [],
            selectedItem: null,
            dialogItem: false
        }
    },
    computed: {
        ...mapState({
            recharges: state => state.recharges.all.data,
            total_recharge: state => state.recharges.all.total,
            summary_recharge: state => state.recharges.all.summary,
            loading: state => state.recharges.loading
        }),
        customer_id() {
            return this.$store.state.authentication.user.id;
        },
    },
    watch: {
        recharge_pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterRechargeConditions = !_.isEmpty(filterConditions) ? filterConditions['account_recharges'] : []
                this.filter_data_recharge();
            },
            deep: true
        }
    },
    methods: {
        refresh_data() {
            this.filter_data_recharge();
        },
        filter_data_recharge() {
            var param = {
                pagination: this.recharge_pagination,
                filter: this.filterRechargeConditions,
                quickFilter: this.quickFilterRechargeConditions
            };
            this.$store.dispatch("recharges/getList", param);
        },
        applyFilterRecharge(filterConditions) {
            let sortBy = this.recharge_pagination.sortBy
            let sortDesc = this.recharge_pagination.sortDesc
            this.recharge_pagination = {...configs.PAGINATION, itemsPerPage: 10};
            this.recharge_pagination.sortBy = sortBy;
            this.recharge_pagination.sortDesc = sortDesc;
            this.filterRechargeConditions = filterConditions;
            this.filter_data_recharge();
        },
        quickFilterRecharge(filterConditions) {
            this.quickFilterRechargeConditions = filterConditions;
            this.filter_data_recharge();
        },
    },
    mounted () {
        this.$root.$emit('COMPONENT_LOADED');
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$on("REQUEST_REFRESH_DATA", this.refresh_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA");
    }
}
</script>